import { render, staticRenderFns } from "./IndoorGlobalSearch.vue?vue&type=template&id=4df96d7a"
import script from "./IndoorGlobalSearch.vue?vue&type=script&lang=js"
export * from "./IndoorGlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports